import React from 'react';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';

const formatExpiryDate = (epochTimestamp) => {
  try {
    const timestamp = epochTimestamp.toString().length === 10 ? 
      epochTimestamp * 1000 : epochTimestamp;
    return format(new Date(timestamp), 'dd MMM yyyy');
  } catch (err) {
    console.error('Error formatting expiry date:', err);
    return epochTimestamp;
  }
};

const InstrumentInfo = ({ instrument }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <Typography variant="body2" sx={{ fontWeight: "medium" }}>
        {instrument.display_name}
      </Typography>
      {(instrument.exchange === "NFO" || instrument.exchange === "MCX") &&
        instrument.expiry &&
        (!instrument.execution || instrument.execution !== "SPREAD") && (
          <Typography variant="caption" color="text.secondary">
            Expiry: {formatExpiryDate(instrument.expiry)}
          </Typography>
        )}
      {instrument.exchange === "NSE" && instrument.description && (
        <Typography variant="caption" color="text.secondary">
          {instrument.description}
        </Typography>
      )}
    </Box>
  );
};

export default InstrumentInfo; 